import { useState } from "react";
import { enableChurch, disableChurch } from "@features/church/api/churchApi";

/**
 * Hook exposing church enable/disable actions and a busy flag.
 * Enable/disable are nation-admin operations (NATION-scoped endpoint).
 */
export function useChurchActions() {
    const [busy, setBusy] = useState(false);

    const doChurchDisable = async (nationId: number, churchId: number) => {
        setBusy(true);
        const response = await disableChurch(nationId, churchId);
        setBusy(false);
        return response;
    };

    const doChurchEnable = async (nationId: number, churchId: number) => {
        setBusy(true);
        const response = await enableChurch(nationId, churchId);
        setBusy(false);
        return response;
    };

    return { busy, doChurchDisable, doChurchEnable };
}
